/** 記事の種類: コラム */
export const ARTICLE_PAGE_TYPE_COLUMN = 'column';
/** 記事の種類: 検討事例 */
export const ARTICLE_PAGE_TYPE_CASE_STUDY = 'case_study';
/** 記事の種類: 相談事例 */
export const ARTICLE_PAGE_TYPE_CONSULTING_CASE = 'consulting_case';
/** 記事の種類: ダウンロード資料 */
export const ARTICLE_PAGE_TYPE_DOCUMENT = 'document';
/** 記事の種類 */
export const ARTICLE_PAGE_TYPES = [
    { label: 'コラム', value: ARTICLE_PAGE_TYPE_COLUMN },
    { label: '検討事例', value: ARTICLE_PAGE_TYPE_CASE_STUDY },
    { label: '相談事例', value: ARTICLE_PAGE_TYPE_CONSULTING_CASE },
    { label: 'ダウンロード資料', value: ARTICLE_PAGE_TYPE_DOCUMENT },
];
